export const DEFAULT_LOCALE = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || '';
export const LOCALES = process.env.NEXT_PUBLIC_LOCALES?.split(',') || [];
export const SCAYLE_API_ENDPOINT =
  process.env.NEXT_PUBLIC_SCAYLE_API_ENDPOINT || '';
export const SCAYLE_API_TOKEN = process.env.NEXT_PUBLIC_SCAYLE_API_TOKEN || '';
export const SCAYLE_AUTH_ID = process.env.SCAYLE_AUTH_ID || '';
export const SCAYLE_AUTH_SECRET = process.env.SCAYLE_AUTH_SECRET || '';
export const SCAYLE_SHOP_ID = Number(process.env.NEXT_PUBLIC_SCAYLE_SHOP_ID);
export const SCAYLE_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;
export const SCAYLE_CHECKOUT_API_ENDPOINT =
  process.env.NEXT_PUBLIC_SCAYLE_CHECKOUT_API_ENDPOINT || '';
export const SCAYLE_AUTH_API_ENDPOINT =
  process.env.NEXT_PUBLIC_SCAYLE_AUTH_API_ENDPOINT || '';
export const SCAYLE_CHECKOUT_BUNDLE =
  process.env.NEXT_PUBLIC_SCAYLE_CHECKOUT_BUNDLE;
export const STORY_BLOK_ACCESS_TOKEN =
  process.env.NEXT_PUBLIC_STORY_BLOK_ACCESS_TOKEN;
export const USERCENTRICS_ID = process.env.NEXT_PUBLIC_USERCENTRICS_ID;
export const IS_PROD = process.env.NODE_ENV === 'production';
export const VIDEOLYSER_HREF = process.env.NEXT_PUBLIC_VIDEOLYSER_HREF;
export const CLIENT_GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const FACT_FINDER_HOST = process.env.FACT_FINDER_HOST;
export const FACT_FINDER_USER = process.env.FACT_FINDER_USER;
export const FACT_FINDER_PASSWORD = process.env.FACT_FINDER_PASSWORD;
export const FACT_FINDER_CHANNEL = process.env.NEXT_PUBLIC_FACT_FINDER_CHANNEL;
export const YOUTUBE_HREF = process.env.NEXT_PUBLIC_YOUTUBE_HREF;
export const BANNER_SERVICE = process.env.BANNER_SERVICE || '';
export const EMARSYS_SHOP_ID = process.env.NEXT_PUBLIC_EMARSYS_SHOP_ID;
export const REVIEW_SOURCE_ID = process.env.NEXT_PUBLIC_REVIEW_SOURCE_ID;
export const SOVENDUS_TRAFFIC_SOURCE_NUMBER =
  process.env.NEXT_PUBLIC_SOVENDUS_TRAFFIC_SOURCE_NUMBER;
export const SOVENDUS_TRAFFIC_MEDIUM_NUMBER =
  process.env.NEXT_PUBLIC_SOVENDUS_TRAFFIC_MEDIUM_NUMBER;
export const TRUSTED_SHOPS_ID = process.env.NEXT_PUBLIC_TRUSTED_SHOPS_ID;
export const PAYPAL_API_BASE_URL = process.env.PAYPAL_API_BASE_URL;
export const PAYPAL_BASE_URL = process.env.NEXT_PUBLIC_PAYPAL_BASE_URL;
export const PAYPAL_SECRET = process.env.PAYPAL_SECRET;
export const PAYPAL_CLIENT_ID = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID;
export const OPTIMIZELY_SDK_KEY = process.env.NEXT_PUBLIC_OPTIMIZELY_SDK_KEY;
export const OPTIMIZELY_PROJECT_ID =
  process.env.NEXT_PUBLIC_OPTIMIZELY_PROJECT_ID;
export const RETURN_GO_SHOP_NAME = process.env.NEXT_PUBLIC_RETURN_GO_SHOP_NAME;
